import Vue from "vue";
import VueRouter from "vue-router";
import TimeSlotReservation from "../views/TimeSlotReservation.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/timeSlotReservation",
    name: "timeSlotReservation",
    component: TimeSlotReservation,
    props: route => ({
      token: route.query.token,
      zipCode: route.query.zipCode,
      uuid: route.query.uuid,
      lang: route.query.lang
    })
  }
];

const router = new VueRouter({
  mode: "history",
  routes
});

export default router;
